<template>
  <div v-if="load">
   <scale-loader/>
  </div>
   <div v-else-if="profile == null">
    <div class="wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
              <h2 class="title text-danger">
                Device: {{cur_id}} not found
              </h2>
              <router-link :to="{path:'/'}">
                To List device
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <tabs parent="device" v-else>
    <tab
        id="profile"
        :name="translate('device.section.profile')"
        :href="url+'/profile'"
        :isVisible="this.$store.getters.getPermissions?.viewDeviceProfile === true"
    >
      <new-profile
          :id="cur_id"
          :device="profile"
          :simcard_list="simcard_list"
          @change="OnChange"
      />
    </tab>

    <tab
      id="stats"
      :name="translate('device.section.stats')"
      :href="url+'/stats'"
      :isVisible="isTabVisible('stats')"
    >
      <overview
        :dev_id="cur_id"
        :profile="profile"
      />
    </tab>

    <tab
      id="traffic"
      :name="translate('device.section.traffic')"
      :href="url+'/traffic'"
      :isVisible="isTabVisible('traffic')"
    >
      <traffic
        :dev_id="dev_id"
        :simcard_list="simcard_list"
      />
    </tab>

    <tab
      id="tickets"
      :name="translate('device.section.tickets')"
      :isVisible="isTabVisible('tickets')"
      :href="url+'/tickets'"
    >
      <tickets
        :device_id="profile.id"
      />
    </tab>

    <tab
      id="config"
      :name="translate('device.section.config')"
      :href="url+'/config'"
      :isVisible="isTabVisible('config')"
    >
      <configuration :fid="cur_id" />
    </tab>

    <tab
      id="logs"
      :name="translate('device.section.logs')"
      :href="url+'/logs'"
      :isVisible="isTabVisible('logs')"
    >
      <logs :dev_id="cur_id" />
    </tab>

    <tab
        id="tasks"
        :name="translate('device.section.tasks')"
        :href="url+'/tasks'"
        :isVisible="isTabVisible('tasks')"
    >
      <DeviceTasks :dev_id="cur_id" />
    </tab>

    <tab
        id="tracking"
        :name="translate('device.section.tracking')"
        :href="url+'/tracking'"
        :isVisible="isTabVisible('tracking')"
    >
      <maps :dev_id="cur_id" />
    </tab>

    <tab
        id="ssh"
        :name="translate('device.section.ssh')"
        :href="url+'/ssh'"
        :isVisible="isTabVisible('ssh')"
    >
      <Ssh :dev_id="cur_id" :servers="server_list"/>
    </tab>

    <tab
        id="testing"
        :name="translate('device.section.selftest')"
        :href="url+'/testing'"
        :isVisible="isTabVisible('testing')"
    >
      <Testing :profile="profile" />
    </tab>

  </tabs>
</template>
<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
// import Profile from './Device/Profile'
import NewProfile from './Device/Profile.vue'
import Overview from './Device/Overview'
import Traffic from './Device/Traffic'
import Tickets from './Device/Tickets'
import Configuration from './Device/Configuration'
import Logs from './Device/Logs'
import DeviceTasks from "./Device/Tasks";
import Maps from './Device/Maps';
import Ssh from "./Device/Ssh";
import Testing from './Device/Testing.vue';


export default {
  name: 'Device',
  components: {
    // Profile,
    NewProfile,
    Tab,
    Tabs,
    Logs,
    Configuration,
    Overview,
    Traffic,
    Tickets,
    DeviceTasks,
    Maps,
    Ssh,
    Testing,
  },
  data () {
    return {
      pred_id: false,
      section: 'profile',
      interval: null,
      device: {},
      change: false,
      simcard_list: []
    }
  },

  computed: {
    server_list(){
      let list = []
      if (this.device.profile.servers) {
        for (let server of this.device.profile.servers) {
          let name = server.name + "( " + server.ip + ")"
          if (server.proxy === 1 && !list.find(server => server.label === name)) {
            list.push({
              label: server.name + "( " + server.ip + ")",
              id: server.ip + ":" + server.port,
              ip: server.ip,
              port: server.port
            })
          }
        }

        list = [...new Set(list)]
      }
      return list
    },
    url () { return '/device/' + this.$route.params.device_id },
    cur_id () { return this.$route.params.device_id },
    dev_id () { return this.profile.id },
    profile () {
      //Изменение имени вкладки
      if (this.$route.name === 'device_section') {
        this.$store.commit('updateOtherTitle', this.device.profile.name2)
      }
      return this.device.profile
    },
    load () { return this.device.load === undefined || this.device.load }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'device_section') {
        this.set_device()
        this.getSimcardList()
      } else {
        clearInterval(this.interval)
        clearInterval(this.intervalSimDev)
      }
    },
    $route () {
      if (this.$route.params.device_section === undefined) {
        return false
      }
    },
    load () {
      clearInterval(this.interval)
      if(this.load === false && this.device.profile !== null) {
        this.interval = setInterval(() => {
          this.$store.dispatch('updateDeviceProfile', this.cur_id)
        }, this.$store.getters.getDeviceProfileUpdate)
      }
    },
  },
  created(){
    this.getSimcardList()
  },

  activated () {
    this.set_device()
  },

  deactivated () {
    this.$store.commit('updateOtherTitle', '')
    clearInterval(this.interval)
    clearInterval(this.intervalSimDev)
  },
  methods: {
    //Перенесено из симкарт
    isTabVisible(tab) {
      switch(tab) {
        case 'ssh': return (this.$store.getters.getPermissions?.runDeviceSsh === true) && (this.server_list?.length > 0);
        case 'tracking': return (this.$store.getters.getPermissions?.viewDeviceTracking === true);
        case 'tasks': return (this.$store.getters.getPermissions?.viewDeviceTasks === true);
        case 'logs': return (this.$store.getters.getPermissions?.viewDeviceLogs === true);
        case 'config': return (this.$store.getters.getPermissions?.viewDeviceConfig === true);
        case 'tickets': return (this.$store.getters.getPermissions?.permissionSupport === true);
        case 'traffic': return (this.$store.getters.getPermissions?.viewDeviceTraffic === true);
        case 'stats': return (this.$store.getters.getPermissions?.viewDeviceStats === true);
        case 'testing': return (
            this.$store.getters.getPermissions?.viewDeviceSelftestResults === true ||
            this.$store.getters.getPermissions?.viewDeviceSnapshot === true ||
            this.$store.getters.getPermissions?.viewDeviceFactoryTest === true
        );
      }
      return false;
    },
    getSimcardList(){
      clearInterval(this.intervalSimDev)
      if (this.$store.getters.getPermissions?.viewDeviceSimcardList === true){
        this.$http.v1.getDeviceSimcards(this.cur_id, (response) => {
          this.simcard_list = response.data
        })
        this.intervalSimDev = setInterval(() => {
          this.$http.v1.getDeviceSimcards(this.cur_id, (response) => {
            this.simcard_list = response.data
          })
        }, this.$store.getters.getDeviceSimcardUpdate)
      }else{
        this.simcard_list = []
      }
    },

    OnChange (value) {
      this.change = value
    },

    set_device () {
      if (this.cur_id) {
        this.device = this.$store.getters.getDeviceById(this.cur_id)
        if (!this.device.profile || !this.device.profile.ts || this.device.profile.ts < Date.now()) {
          this.$store.dispatch('updateDeviceProfile', this.cur_id)
        }
      }
    }
  }
}

</script>
